module.exports = __webpack_public_path__ + "img/DTI-04.322bcc2e.png";